import { Injectable } from "@angular/core";
import { EsEvent } from "./type-defs";

@Injectable({
    providedIn: "root", //TODO: needs to be null once it can be injected in the EventsPage component
})
export class EventsPageService {
    private selectedEvents: Record<string, EsEvent> = {}; // Indexed by ES _id

    selectEvent(newEvent: EsEvent): void {
        if (newEvent._id in this.selectedEvents) {
            delete this.selectedEvents[newEvent._id];
        } else {
            this.selectedEvents[newEvent._id] = newEvent;
        }
    }

    getEvents(): EsEvent[] {
        return Object.values(this.selectedEvents);
    }

    countEvents(): number {
        return Object.values(this.selectedEvents).length;
    }

    replaceEvents(newEvents: EsEvent[]): void {
        const selectedEvents = {};
        newEvents.forEach(e => selectedEvents[e._id] = e);
        this.selectedEvents = selectedEvents;
    }

    clear(): void {
        this.selectedEvents = {};
    }
}
